/**
 * Enum representing the different divisions in the system
 */
export enum Division {
  Transportation = 1,
  Leasing = 2,
  Factoring = 3,
  Corporate = 4
}



// WEBPACK FOOTER //
// ./src/app/core/constants/division.ts